import { render, staticRenderFns } from "./myCourse.vue?vue&type=template&id=6df0b978&"
import script from "./myCourse.vue?vue&type=script&lang=js&"
export * from "./myCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports